// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__container-Q_MhxN {
  flex-shrink: 0;
  justify-content: flex-start;
  align-self: stretch;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-left: 8px;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__container-Q_MhxN .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-no-uz4u09 {
  align-items: center;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__container-Q_MhxN .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-no-uz4u09 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-AFTo5d {
  cursor: pointer;
  color: #888d92;
  width: 20px;
  height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__container-Q_MhxN .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-no-uz4u09 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-AFTo5d.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__disabled-YksBvb {
  cursor: not-allowed;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__container-Q_MhxN .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-no-uz4u09 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-AFTo5d > svg {
  width: 20px;
  height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__container-Q_MhxN .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__add-dhS6yw {
  color: #4d53e8;
  cursor: pointer;
  margin-left: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__container-Q_MhxN`,
	"icon-no": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-no-uz4u09`,
	"iconNo": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-no-uz4u09`,
	"icon": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__icon-AFTo5d`,
	"disabled": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__disabled-YksBvb`,
	"add": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-operator-index-module__add-dhS6yw`
};
export default ___CSS_LOADER_EXPORT___;
